var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS8KreisGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    width: 150,
    height: 150,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8500000238418579
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.8,75.8a13.402,13.402,0,0,1-.1,2,38.77155,38.77155,0,0,1-77.5-1.9c0-1.2.1-2.5.2-3.7h.2a33.93394,33.93394,0,0,0,5.5-.4,35.2845,35.2845,0,0,0,5.6-1.4,32.74252,32.74252,0,0,0,6.4-2.8A36.30932,36.30932,0,0,0,71.9,42.7a50.49937,50.49937,0,0,0,.6-5.6h2.7a15.4845,15.4845,0,0,1,2.2.1c.5,0,.9.1,1.4.1.8.1,1.5.2,2.3.3a23.81238,23.81238,0,0,1,2.6.5,37.75635,37.75635,0,0,1,11.6,4.7c.3.2.5.3.8.5s.5.3.8.5a14.30917,14.30917,0,0,1,1.5,1.1c.8.6,1.5,1.2,2.2,1.8.4.4.9.8,1.3,1.2a4.61984,4.61984,0,0,1,.7.7,50.42255,50.42255,0,0,1,3.7,4.2h0c.4.5.7,1,1.1,1.5h0c.3.5.7,1,1,1.6h0c.3.5.6,1.1.9,1.6s.6,1.1.9,1.7a33.82752,33.82752,0,0,1,1.8,4.4l.3.9.3.9a28.63542,28.63542,0,0,1,.7,2.8c.1.6.2,1.3.3,1.9a14.27919,14.27919,0,0,1,.3,2.9h0a2.76856,2.76856,0,0,0,.1.9A5.84426,5.84426,0,0,0,113.8,75.8Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.8,73.9h0a3.08284,3.08284,0,0,0-.1-1c0-.5-.1-1-.1-1.5-.1-.5-.1-1-.2-1.5-.1-.6-.2-1.3-.3-1.9a28.64114,28.64114,0,0,0-.7-2.8l-.3-.9-.3-.9A33.82747,33.82747,0,0,0,110,59c-.3-.6-.6-1.1-.9-1.7s-.6-1.1-.9-1.6h0c-.3-.5-.7-1-1-1.6h0a14.3106,14.3106,0,0,0-1.1-1.5h0a19.16671,19.16671,0,0,0-1.8-2.2c-.7-.7-1.2-1.4-1.9-2a4.61974,4.61974,0,0,0-.7-.7c-.4-.4-.9-.8-1.3-1.2-.7-.6-1.5-1.2-2.2-1.8-.5-.4-1-.7-1.5-1.1-.3-.2-.5-.3-.8-.5s-.5-.3-.8-.5a37.75659,37.75659,0,0,0-11.6-4.7,19.96852,19.96852,0,0,0-2.6-.5c-.7-.1-1.5-.2-2.3-.3-.4,0-.9-.1-1.4-.1-.7,0-1.5-.1-2.2-.1H72.4a26.65833,26.65833,0,0,1-.6,5.6c1.1-.1,2.1-.2,3.2-.2a33.246,33.246,0,0,1,33.2,33.2C108.2,93.8,93.3,109,75,109A33.246,33.246,0,0,1,41.8,75.8a26.92927,26.92927,0,0,1,.3-4,33.93281,33.93281,0,0,1-5.5.4h-.2c-.1,1.2-.2,2.4-.2,3.7a38.79294,38.79294,0,0,0,77.4,3.8,12.1021,12.1021,0,0,0,.1-1.9c0-.7.1-1.3.1-2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.5,82.4c0,6.8-5.6,10.6-13.2,10.6-8.8-.1-14.1-4.2-14.1-11.2H53c.6,4.1,2.6,5.6,7.6,5.6,3.5,0,6.5-1.2,6.5-4.4s-3.2-3.8-8.2-5c-5.2-1.3-10.1-2.5-11.2-7.6a32.74244,32.74244,0,0,0,6.4-2.8c.1,2.4,2.5,3.3,7.4,4.4C67.9,73.6,73.5,75,73.5,82.4Z",
    style: {
      fill: "#ffcb00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2,63.6h-.4a33.87856,33.87856,0,0,0,4.9-5.1c5,1.2,8.1,4.7,8.5,10.1H66.7C66.4,65.1,63.8,63.6,60.2,63.6Z",
    style: {
      fill: "#ffcb00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3,74.4c2.6-1.5,4.4-3.6,4.4-6.5,0-5.6-4.4-8.5-11.5-8.5s-11.8,2.9-11.8,8.5v.4a6.45952,6.45952,0,0,0,4.4,6.1,8.8295,8.8295,0,0,0-5.9,8.5c0,6.5,5.9,10,13.4,10,7.3,0,12.9-3.5,12.9-10.3h0A8.71522,8.71522,0,0,0,98.3,74.4Zm-7.1-10c3.2,0,5.3,1.5,5.3,4.1,0,2.4-2.1,4.1-5.3,4.4-3.2,0-5.3-2-5.3-4.4C85.9,66.2,87.7,64.4,91.2,64.4Zm0,23.2c-4.1,0-6.5-1.8-6.5-5,0-3.5,2.7-5.6,6.5-5.6s6.2,2.4,6.2,5.6C97.4,85.6,94.7,87.6,91.2,87.6Z",
    style: {
      fill: "#ffcb00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1,37.2h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2,36.3a30.95,30.95,0,1,1-30.9-31,30.87757,30.87757,0,0,1,30.9,31Z",
    style: {
      fill: "#353535"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2,17.2A15.4496,15.4496,0,0,0,20.7,32.7c0,12,15.5,22.9,15.5,22.9S51.7,44,51.7,32.7A15.5133,15.5133,0,0,0,36.2,17.2Zm0,22.7a7.6,7.6,0,1,1,7.6-7.6A7.59663,7.59663,0,0,1,36.2,39.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9,13.5,59.2,53.6l-4.1,3.9L14.3,17.2Z",
    style: {
      fill: "#ec0016"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2,10.4a26.00019,26.00019,0,1,1-25.9,26,26.07631,26.07631,0,0,1,25.9-26m0-5a30.95,30.95,0,1,0,30.9,31h0a30.81439,30.81439,0,0,0-30.9-31Z",
    style: {
      fill: "#353535"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS8KreisGray);
export default __webpack_public_path__ + "static/media/s8kreis-gray.c2617f7841e45ebee4f7e3c1962c6f1b.svg";
export { ForwardRef as ReactComponent };